import { LeafElementDestination } from '../destination';
export class DocumentVersionDestination extends LeafElementDestination {
}
